import "../output.css";

const PrivacyPolicy = () => {
  return (
    <div style={{backgroundColor: '#121111'}}>
      <div
        style={{ textUnderlinePosition: "under" }}
        className="container mx-auto text-gray-100 font-mono underline py-8 pl-8 w-full font-bold overflow-hidden text-xl sm:text-lg md:text-3xl lg:text-3xl"
      >
        <span>Privacy Policy for Sedecordle</span>
      </div>
      <div className="container w-full mx-auto pl-8">
        <article className="prose lg:prose-xl font-mono text-base sm:text-sm md:text-lg lg:text-lg text-gray-300">
          <div className="flex flex-wrap">
            <h2>Our Use of Cookies</h2>
            <p>
              A cookie is a file containing an identifier (a string of letters
              and numbers) that is sent by a web server to a web browser and is
              stored by the browser. The identifier is then sent back to the
              server each time the browser requests a page from the server.
              Cookies may be either "persistent" cookies or "session" cookies: a
              persistent cookie will be stored by a web browser and will remain
              valid until its set expiry date, unless deleted by the user before
              the expiry date; a session cookie, on the other hand, will expire
              at the end of the user session, when the web browser is closed.
               Cookies do not typically contain any information that personally
              identifies a user, but personal information that we store about
              you may be linked to the information stored in and obtained from
              cookies.
            </p>

            <p>
              We use Google Analytics to analyze the use of our website. Google
              Analytics gathers information about website use by means of
              cookies. The information gathered relating to our website is used
              to create reports about the use of our website. Google's privacy
              policy is available at:
              <a href="https://www.google.com/policies/privacy/">
                https://www.google.com/policies/privacy/
              </a>
            </p>

            <p>
              Most browsers allow you to refuse to accept cookies and to delete
              cookies. The methods for doing so vary from browser to browser,
              and from version to version. You can however obtain up-to-date
              information about blocking and deleting cookies via these links:
            </p>
            <ul>
              <li>
                (a) https://support.google.com/chrome/answer/95647?hl=en (Chrome);
              </li>
              <li>
                (b) https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences (Firefox);
              </li>
              <li>
                (c) http://www.opera.com/help/tutorials/security/cookies/ (Opera);
              </li>
              <li>
                (d) https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies (Internet
                Explorer);
              </li>
              <li>
                (e) https://support.apple.com/en-gb/guide/safari/sfri11471/mac (Safari);
                and
              </li>
              <li>
                (f) https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy (Edge).
              </li>
            </ul>
            <p>
              Please note that blocking cookies may have a negative impact on
              the functions of many websites, including our Site. Some features
              of the Site may cease to be available to you.
            </p>

            <h2>Advertising</h2>
            <p>
              This Site is affiliated with CMI Marketing, Inc., d/b/a CafeMedia
              (“CafeMedia”) for the purposes of placing advertising on the Site,
              and CafeMedia will collect and use certain data for advertising
              purposes. To learn more about CafeMedia’s data usage, click here:
              <a href="https://www.cafemedia.com/publisher-advertising-privacy-policy">
                https://www.cafemedia.com/publisher-advertising-privacy-policy
              </a>
            </p>

            <p>
              If you have any questions about this Privacy Policy or the
              practices of this site, please contact us at{" "}
              <a href="mail:hello@sedecordle.com">hello@sedecordle.com</a>
            </p>
          </div>
        </article>

        <div className="pb-8">
          <button className="tracking-widest bg-black uppercase font-mono hover:bg-gray-700 text-white font-semibold py-2 px-4 border border-yellow-300 rounded">
            <a
              style={{ textDecoration: "none" }}
              href="/"
              className="text-white"
            >
              Go back to Home
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
